import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeToast } from '../../store/slices/toastSlice';
import './ToastContainer.css';

const AUTO_TIMEOUT = 4500;

const Toast = ({ toast, onDismiss }) => {
  useEffect(() => {
    const id = setTimeout(() => onDismiss(toast.id), AUTO_TIMEOUT);
    return () => clearTimeout(id);
  }, [toast.id, onDismiss]);
  return (
    <div className={`toast toast-${toast.type}`}> 
      <span className="toast-message">{toast.message}</span>
      <button className="toast-dismiss" onClick={() => onDismiss(toast.id)}>×</button>
    </div>
  );
};

const ToastContainer = () => {
  const toasts = useSelector(s => s.toasts);
  const dispatch = useDispatch();
  return (
    <div className="toast-container">
      {toasts.map(t => <Toast key={t.id} toast={t} onDismiss={(id) => dispatch(removeToast(id))} />)}
    </div>
  );
};

export default ToastContainer;